//import React from "react";
// import { AiOutlineTable } from "react-icons/ai";
// import { TextField } from "@mui/material";
// import { MenuItem } from "@mui/material";
import Sidebar from "../../Sidebar/Sidebar";
import "../Reports/Reports.css";
import "../Reports/mediaquery.css"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
//import * as XLSX from "xlsx";

import { TextField, MenuItem, Chip, } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  Box,
  Card,
  Typography,
  Button,
  Divider,
  Grid
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import useReports from "./useReports";

const Reports = () => {
  const {
    isOpen, openView, objData, visible,
    borrowerReportVisible, loanReportVisible, disbursedReportVisible, masterReportVisible, rfdReportVisible, coappReportVisible, 
    QueryRaisedVisible, QueryResolvedVisible, borrowerReportSectionVisible, report_history, rowNumber, currentPage, totalPages, 
    totalRecords, response_msg, goToNextPage, goToPrevPage, paginationViewHandler, handleChange, handleChangeDate, handleClick, 
    download_report, formatDate, loanApplicationReportVisible, loanApplicationDynamicReportVisible, loading, downloadingId, loginMISReportVisible
  } = useReports();


  return (
    <>

      <div style={{ height: "20px" }} />
      <Sidebar click={openView} dataSend={"Reports"} />
      <div style={{ marginLeft: isOpen ? "14%" : "0", transition: "all 0.2s" }}>
        <div className="report-main">
          <Box className="report-form">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 3,
              }}
            >
              <SettingsIcon sx={{ fontSize: "2.5ch", color: "blue" }} />
              <Typography variant="h6" fontWeight={600}>
                Generate New Reports
              </Typography>
            </Box>

            <form onSubmit={handleClick} >
              <Grid container spacing={3} sx={
                {
                  display: "flex",
                  flexDirection: "column",
                }
              }>
                {/* Report Type */}
                <Grid item xs={12} md={6}>
                  <Typography mb={1}>Report Type</Typography>
                  <TextField
                    required
                    select
                    fullWidth
                    name="report-type"
                    variant="outlined"
                    value={objData["report-type"] || ""}
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#ebebeb",
                        borderRadius: 3,
                        width: "14rem"
                      },
                    }}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            borderRadius: "16px",
                            mt: 1,
                            boxShadow: "0px 8px 24px rgba(0,0,0,0.15)",
                          },
                        },
                        sx: {
                          borderRadius: "16px",
                          mt: 1,
                          // backdropFilter: "blur(4px)",
                        },
                      },
                    }}
                    onChange={handleChange}
                  >
                    { (loginMISReportVisible || visible) && (
                      <MenuItem value="loginMIS">Login MIS</MenuItem>
                    )}
                    {(borrowerReportVisible || visible) && (
                      <MenuItem value="borrower">Borrower Report</MenuItem>
                    )}
                    {(loanReportVisible || visible) && (
                      <MenuItem value="loan">Loan Report</MenuItem>
                    )}
                    {(loanApplicationReportVisible || visible) && (
                      <MenuItem value="application">Loan Application</MenuItem>
                    )}
                    {(loanApplicationDynamicReportVisible || visible) && (
                      <MenuItem value="DynamicApplication">Dynamic Loan Application</MenuItem>
                    )}
                    {(disbursedReportVisible || visible) && (
                      <MenuItem value="disbursed">
                        Loan Disbursement Report
                      </MenuItem>
                    )}
                    {(masterReportVisible || visible) && (
                      <MenuItem value="master">Master Report</MenuItem>
                    )}
                    {(coappReportVisible || visible) && (
                      <MenuItem value="coapplicant">Coapplicant Report</MenuItem>
                    )}
                    {(rfdReportVisible || visible) && (
                      <MenuItem value="rfd">RFD Report</MenuItem>
                    )}
                    {(QueryRaisedVisible || visible) && (
                      <MenuItem value="QueryRaised">Query Raised</MenuItem>
                    )}
                    {(QueryResolvedVisible || visible) && (
                      <MenuItem value="QueryResolved">Query Resolved</MenuItem>
                    )}
                    {(QueryResolvedVisible || visible) && (
                      <MenuItem value="LoanStatus">Loan Status</MenuItem>
                    )}
                    {(QueryResolvedVisible || visible) && (
                      <MenuItem value="Oversight">Oversight Review</MenuItem>
                    )}
                  </TextField>
                </Grid>

                {/* Sections */}
                {borrowerReportSectionVisible && (
                  <Grid item xs={12} md={6} sx={{
                    "& .MuiOutlinedInput-root": {
                      width: "14rem",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      justifyItems: "center",
                      alignContent: "center",
                      alignItems: "center",
                    },
                  }}>
                    {/* 
                    <Typography
                      mb={1}
                      sx={{
                        width: "14rem",
                      }}
                    >
                      Select Sections (Max 3)
                    </Typography> */}

                    {/* <FormControl fullWidth>
                      <Select
                        multiple
                        size="small"
                        value={objData1["additional-select"]}
                        onChange={handleChangeSection}
                        sx={{
                          backgroundColor: "#ebebeb",
                          borderRadius: 3,
                        }}
                        renderValue={(selected) => (
                          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                            {selected.map((value) => (
                              <Chip key={value} label={value} size="small" />
                            ))}
                          </Box>
                        )}
                      >
                        <MenuItem value="personal">Personal Details</MenuItem>
                        <MenuItem value="address">Address Details</MenuItem>
                        <MenuItem value="bank">Bank Details</MenuItem>
                        <MenuItem value="reference">Reference Details</MenuItem>
                        <MenuItem value="family">Family Details</MenuItem>
                        <MenuItem value="primary">Primary Occupation Details</MenuItem>
                        <MenuItem value="surrogate">
                          Surrogate Occupation Details
                        </MenuItem>
                      </Select>
                    </FormControl> */}
                  </Grid>
                )}

                {/* From Date */}

                <Grid item xs={12} md={6} SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      sx: {
                        borderRadius: "16px",
                        mt: 1,
                        boxShadow: "0px 8px 24px rgba(0,0,0,0.15)",
                      },
                    },
                    sx: {
                      borderRadius: "16px",
                      mt: 1,
                      // backdropFilter: "blur(8px)",
                    },
                  },
                }}>
                  <Typography mb={1}>From Date</Typography>
                  <TextField
                    required
                    type="date"
                    fullWidth
                    name="from-date"
                    size="small"
                    value={objData["from-date"]}
                    sx={{
                      width: "14rem",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#ebebeb",
                        borderRadius: 3,
                      },
                    }}
                    onChange={handleChangeDate}
                    inputProps={{
                        max: new Date().toISOString().split("T")[0],
                    }}
                  />
                </Grid>

                {/* To Date */}
                <Grid item xs={12} md={6}>
                  <Typography mb={1}>To Date</Typography>
                  <TextField
                    required
                    type="date"
                    fullWidth
                    name="to-date"
                    size="small"
                    value={objData["to-date"]}
                    sx={{
                      width: "14rem",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#ebebeb",
                        borderRadius: 3,
                      },
                    }}
                    onChange={handleChangeDate}
                    inputProps={{
                        max: new Date().toISOString().split("T")[0],
                    }}
                  />
                </Grid>

                {/* Button */}
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      width: "14rem",
                      backgroundColor: "blue",
                      mt: 2,
                      textTransform: "none",
                      borderRadius: 2,
                      px: 4,
                    }}
                  >
                    Generate Report
                  </Button>
                </Grid>
              </Grid>
            </form>

          </Box>
          <div className="report-history">
            <div className="report-history-list">
              <Card
                sx={{
                  borderRadius: "16px",
                  boxShadow: "4px 4px 40px rgba(0,0,0,0.08)",
                  p: 3,
                  width: "100%",
                  fontFamily: "arial, sans-serif"
                }}
              >
                {/* Header */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Box>
                    <Typography fontWeight={700} fontSize="1.1rem">
                      Report History
                    </Typography>
                    <Typography color="text.secondary" fontSize="0.85rem">
                      Personal Activity Feed
                    </Typography>
                  </Box>

                  <Typography color="text.secondary" fontSize="0.85rem">
                    {totalRecords} Total
                  </Typography>
                </Box>

                {/* Column Headers */}
                <Box
                  display="grid"
                  gridTemplateColumns="1.2fr 2fr 1.2fr 0.8fr"
                  px={1}
                  py={1}
                >
                  {["USER NAME", "REPORT DETAILS", "DATE GENERATED", "EXPORT"]?.map(
                    (item) => (
                      <Typography
                        key={item}
                        fontSize="0.75rem"
                        fontWeight={700}
                        color="text.secondary"
                      >
                        {item}
                      </Typography>
                    )
                  )}
                </Box>

                <Divider />

                {/* Rows */}
                <div className="scrollBox"
                  style={{ height: "55vh", overflowY: "auto" }} >
                  {report_history.length === 0 && <h4 className="loder">{response_msg}</h4>}
                  {report_history?.map((report, index) => (
                    <Box id="scrollBox" key={index}>
                      <Box
                        display="grid"
                        gridTemplateColumns="1.2fr 2fr 1.2fr 0.8fr"
                        alignItems="center"
                        fontFamily="arial, sans-serif"
                        px={1}
                        py={2}
                      >
                        {/* User */}
                        <Box>
                          <Typography fontWeight={200} fontSize="0.90rem">{report.username}</Typography>
                          <Typography fontSize="0.75rem" color="text.secondary">
                            ID: {report?.user_id}
                          </Typography>
                          <Typography fontSize="0.75rem" color="text.secondary">
                            File ID: {report?._id ?? "Fetching...."}
                          </Typography>
                        </Box>

                        {/* Report Details */}
                        <Box>
                          <Typography fontWeight={200} fontSize="0.90rem">{report?.reportName?.toUpperCase().replaceAll('_', " ")}{ }</Typography>
                          <Typography fontSize="0.75rem" color="text.secondary">
                            Period: {formatDate(report?.start_date)}{" to "}{formatDate(report?.end_date)}
                          </Typography>

                          <Chip
                            label={report?.status?.toUpperCase()}
                            size="small"
                            sx={{
                              mt: 0.5,
                              fontSize: "0.7rem",
                              fontWeight: 700,
                              backgroundColor:
                                ((report?.status === "COMPLETED" ? "#E8F7EF" : (report?.status === "DATA NOT FOUND" ? "#fab6bb" : "#e8d297"))
                                ),
                              color: "#1B8F5A",
                            }}
                          />

                        </Box>

                        {/* Date */}
                        <Box>
                          <Typography fontWeight={200} fontSize="0.90rem">{(report?.download_date?.replaceAll('/', '-'))}</Typography>
                          <Typography fontSize="0.75rem" color="text.secondary">
                            {report?.download_time}
                          </Typography>
                        </Box>

                        {/* Export */}
                        <Button
                          disabled={report?.status === "IN QUEUE" || report?.status === "PROCESSING" || report?.status === "DATA NOT FOUND"}
                          onClick={() => {
                            download_report(report?.file_key, report?._id, report?.reportName)
                          }}
                          startIcon={
                            downloadingId === report._id
                              ? <RotateLeftIcon />
                              : <DownloadIcon />
                          }
                          sx={{
                            textTransform: "none",
                            fontWeight: 700,
                            fontSize: "0.75rem",
                            backgroundColor: "#E8F7EF",
                            color: "#1B8F5A",
                            borderRadius: "8px",
                            px: 2,

                            "&:hover": {
                              backgroundColor: "#DDF2E8",
                              cursor: ((report?.status === "IN QUEUE" || report?.status === "PROCESSING" || report?.status === "DATA NOT FOUND") ? "not-allowed" : "pointer"),
                            },
                            "&.Mui-disabled": {
                              cursor: "not-allowed",
                              pointerEvents: "auto",
                              color: "#9E9E9E",
                              backgroundColor: "#F5F5F5",
                            },
                          }}
                        >
                          XLSX
                        </Button>
                      </Box>

                      {index !== report_history.length - 1 && <Divider />}
                    </Box>
                  ))}
                </div>
              </Card>
              <Backdrop
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  zIndex: 10,
                  color: "#fff",
                  borderRadius: "18px",
                }}
                open={loading}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            </div>
            <div className="Pagination">
              <label>Entries To Display</label>
              <div >
                <TextField
                  placeholder="rows"
                  select
                  name="created-data"
                  variant="outlined"
                  value={rowNumber}
                  size="small"
                  onChange={paginationViewHandler}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </TextField>
              </div>
              <div >
                <button
                  disabled={currentPage === 1}
                  style={{
                    padding: "0.5rem",
                    color: "white",
                    width: "14rem",
                    backgroundColor: "blue",
                    borderRadius: "2rem",
                    px: 4,
                    cursor: (currentPage === 1 ? "not-allowed" : "pointer")
                  }} onClick={goToPrevPage} >Previous</button>
              </div>
              <span className="pageCount" style={{ textAlign: "center", borderRadius: "2rem", width: "14rem", }}>{currentPage}</span>
              <div >
                <button
                  disabled={currentPage === totalPages}
                  onClick={goToNextPage}
                  style={{
                    padding: "0.5rem",
                    color: "white",
                    width: "14rem",
                    backgroundColor: "blue",
                    borderRadius: "2rem",
                    px: 4,
                    cursor: (currentPage === totalPages ? "not-allowed" : "pointer")
                  }}>Next</button>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop> */}
      </div>
    </>
  );
};

export default Reports;